package com.patronat.top.features.usermanagement.presentation.create

import com.patronat.top.features.usermanagement.domain.models.UserStatus
import com.patronat.top.ui.molecules.UiStatusItem
import com.patronat.top.ui.molecules.UiStatusStyle

fun UserStatus.toUiItem(): UiStatusItem<UserStatus> {
    return UiStatusItem(
        label = this.getLabel(),
        value = this,
        style = when (this) {
            UserStatus.ACTIVE -> UiStatusStyle.ACTIVE
            UserStatus.INACTIVE -> UiStatusStyle.INACTIVE
        }
    )
}

private fun UserStatus.getLabel(): String {
    return when (this) {
        UserStatus.ACTIVE -> "Активний"
        UserStatus.INACTIVE -> "Неактивний"
    }
}